module.exports = __webpack_public_path__ + "static/media/εἰμί_img.b26aa072.JPG";